export enum CollaborationProgressSessionHeaderSkillsTabs {
  TaskPerformance = 'TaskPerformance',
  SkillsDevelopment = 'SkillsDevelopment',
  WhatToImprove = 'WhatToImprove',
  PutIntoPractice = 'PutIntoPractice'
}
